import { useEffect } from 'react'
import { Routes, Route, Navigate, useParams, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  supportedLanguages,
  defaultLanguage,
  type SupportedLanguage,
} from '@/i18n'
import { Header, Footer } from '@/components/layout'
import Home from '@/pages/Home'
import Services from '@/pages/Services'
import Projects from '@/pages/Projects'
import Contacts from '@/pages/Contacts'
import Privacy from '@/pages/Privacy'

function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang as SupportedLanguage)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n])

  // Redirect invalid language to default
  if (!lang || !supportedLanguages.includes(lang as SupportedLanguage)) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[1000] focus:bg-brand focus:text-white focus:px-4 focus:py-2"
      >
        Vai al contenuto
      </a>
      <Header />
      <Outlet />
      <Footer />
    </div>
  )
}

export function LanguageRouter() {
  return (
    <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />

      {/* Language-prefixed routes */}
      <Route path="/:lang" element={<LanguageWrapper />}>
        <Route index element={<Home />} />
        <Route path="servizi" element={<Services />} />
        <Route path="services" element={<Services />} />
        <Route path="progetti" element={<Projects />} />
        <Route path="projects" element={<Projects />} />
        <Route path="contatti" element={<Contacts />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="privacy" element={<Privacy />} />
      </Route>
    </Routes>
  )
}
